import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const enableLMSStoreAPISelector = createSelector(testTargetOffersSelector, offers => !!offers.isLMSStoreAPIABTestEnabled);

export { enableLMSStoreAPISelector };
